import { Component, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SousTraitantService } from '../../../core/services/sous-traitant.service';
import { FormValidators } from '../../../core/validators/form-validators';

@Component({
  selector: 'app-sous-traitant-create',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink, MatIconModule],
  templateUrl: `./sous-traitant-create.component.html`,
  styleUrls: [`./sous-traitant-create.component.css`]
})
export class SousTraitantCreateComponent {
  private fb = inject(FormBuilder);
  private stService = inject(SousTraitantService);
  private router = inject(Router);

  isLoading = signal(false);
  errorMessage = signal<string | null>(null);

  stForm = this.fb.group({
    codeComptable: ['', [Validators.required]],
    denomination: ['', [Validators.required]],
    siret: ['', [FormValidators.siret()]],
    qualification: [''],
    adresse: ['', [Validators.required]],
    ville: ['', [Validators.required]],
    codePostal: ['', [Validators.required, FormValidators.codePostalFr()]]
  });

  onSubmit() {
    // Marque tous les champs comme touchés pour afficher les erreurs
    this.stForm.markAllAsTouched();
    if (this.stForm.invalid) {
      return;
    }

    if (this.stForm.valid) {
      this.isLoading.set(true);
      this.errorMessage.set(null);

      this.stService.createSousTraitant(this.stForm.value as any).subscribe({
        next: () => {
          this.router.navigate(['/sous-traitants']);
        },
        error: (err) => {
          this.errorMessage.set(err?.error?.message || err?.error || 'Une erreur est survenue lors de la création du sous-traitant.');
          this.isLoading.set(false);
        }
      });
    }
  }
}
